import {Component, Inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ProjectService} from '../project/project.service';
import {HttpClient} from '@angular/common/http';
import Player from '@vimeo/player';

@Component({
  selector:'imageViewer',
  template:`
  <div class="card" style="width: 18rem;">
    <img *ngIf="!isVimeo && link!=null" class="card-img-top" [src]="link | secure | async" alt="Card image cap">
    <div *ngIf="isVimeo">
      <!--<vg-player>

        <vg-controls vgFor="my-video" [vgAutohide]="true" [vgAutohideTime]="5">
          <vg-play-pause vgFor="my-video"></vg-play-pause>
          <vg-playback-button vgFor="my-video" [playbackValues]="[ '1.0', '2.0', '4.0' ]"></vg-playback-button>
          <vg-track-selector vgFor="my-video"></vg-track-selector>
          <vg-mute vgFor="my-video"></vg-mute>
          <vg-volume vgFor="my-video"></vg-volume>-->
          <!-- more components here -->
        <!--</vg-controls>
        <video [vgMedia]="media" #media id="my-video" preload="auto" (onPlayerReady)="onPlayerReady($event)" controls>
          <source [src]="link" type="video/mp4">
        </video>
      </vg-player>
      <video width="320" height="240" controls>
        <source
                [src]="_vimeoUrl| secure | async">
      </video>

      <iframe width="300" height="300"
              [src]="link| secure | async">
      </iframe>

      <div style="padding:56.25% 0 0 0;position:relative;"><iframe [src]="_vimeoUrl | secure | async" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Untitled"></iframe></div>
        <div [innerHTML]="fetchedHtml"></div>-->
      <div data-vimeo-id="19231868" data-vimeo-width="640" id="handstick"></div>
    </div>
  </div>`
})

export class ImageViewerComponent implements OnChanges {

  @Input() answer ='';

  private isVimeo = false;

  private _vimeoUrl:any;

  iframe_html: any;

  link = '';

  fetchedHtml = '';

  constructor(@Inject(DOCUMENT) private document: Document,private _projectService:ProjectService,private http: HttpClient) {
  }


  private getResourceUrl(answer:string) {
    this._projectService.getResourceLink(answer.substr(5)).subscribe((resp)=> {
      this.link = resp;
    });
  }

  private vimeoPreviewer(vimeoID:string) {
    const tmp = vimeoID.split(':')[1];

    /*const player = new Player('handstick', {
      id: tmp,
      width: 640
    });

    player.on('play', function() {
      console.log('played the video!');
    });*/

    // this.iframe_html = this.embedService.embed('www.youtube.com/watch?v=iHhcHTlGtRs');// 'https://player.vimeo.com/video/'+tmp);
    this._vimeoUrl =  'https://player.vimeo.com/video/'+tmp+'?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
    return this._vimeoUrl;
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(this.answer.includes('vimeo')) {
      this.isVimeo = true;
      this.vimeoPreviewer(this.answer);
      window.open(this._vimeoUrl,'');
      // this.fetchWebsite();



      return;
    }
    this.isVimeo =false;
    this.getResourceUrl(this.answer);
  }

  private fetchWebsite() {
    const headers = new Headers();
    headers.append('x-forwarded-host', 'foo');
    this.http.get(this._vimeoUrl).subscribe(response => {
      this.fetchedHtml = response.toString();
    });
  }
}
